import { BrowserRouter } from 'react-router-dom';
import { AppRoutes } from './router';
import ScrollToTop from './components/base/ScrollToTop';

function App() {
  return (
    <BrowserRouter basename={__BASE_PATH__}>
      <ScrollToTop />
      <div className="App">
        <AppRoutes />
      </div>
    </BrowserRouter>
  );
}

export default App;